var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { types } from 'mobx-state-tree';
import _ from 'lodash';
import { findById, deleteById, isArray } from '../../helpers/ArrayHelpers';
var createInstanceCache = function (modelType) {
    return types.model({ instances: types.optional(types.array(modelType), []) })
        .named(modelType.name + "InstanceCache")
        .views(function (self) { return ({
        get: function (id) {
            return findById(self.instances, id);
        },
        getMany: function (ids) {
            return self.instances.filter(function (x) { return ids.includes(x.id); });
        }
    }); })
        .actions(function (self) { return ({
        /**
         * Creates and adds the entity, if no instance of this entity is cached
         * If an instance is cached, we apply the snapshot
         * @param entity the newest version of the entity
         */
        addOrApplySnapshot: function (entity) {
            var _a;
            if (isArray(entity)) {
                var newEntities_1 = [];
                // first we remove duplicates to improve performance
                // also we remove duplicates, because otherwise we add duplicates maybe to newEntities
                // because we check the if the entity exists against the local instances
                entity = _.uniqBy(entity, function (x) { return x.id; });
                entity.forEach(function (ent) {
                    var instance = self.get(ent.id);
                    // if instance was found => apply patch-snapshot
                    if (instance) {
                        instance.applySnapshot(ent);
                    }
                    else {
                        newEntities_1.push(ent);
                    }
                });
                (_a = self.instances).push.apply(_a, __spreadArray([], __read(newEntities_1), false));
            }
            else {
                var instance = self.get(entity.id);
                // if instance was found => apply patch-snapshot
                if (instance) {
                    instance.applySnapshot(entity);
                    return;
                }
                // otherwise we add the new entity
                self.instances.push(entity);
            }
        },
        applyPatch: function (id, jsonPatchDocument) {
            // ToDo: implement support for local database here
            var instance = self.get(id);
            if (!instance) {
                // ToDo: handle this error somehow
                return;
            }
            instance.applyPatch(jsonPatchDocument);
        },
        delete: function (id) {
            deleteById(self.instances, id);
        },
        deleteAll: function () {
            self.instances.clear();
        }
    }); });
};
export default createInstanceCache;
//
// UserStore : BaseStore
// UserStoreSubType ()
// types.compose(subType, BaseStore(User))
//# sourceMappingURL=InstanceCache.js.map